export default "__VITE_ASSET__NFu5XtMA__"